export const hideColumsDependingOnWindowSize = (dispatch) => {
    if (window.innerWidth >= 1500) {
        dispatch({ type: 'RESET_HIDDEN_COLUMNS' });
    }
    if (window.innerWidth <= 1544) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['category'], showCustomCols: true });
    }
    if (window.innerWidth <= 1470) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['status', 'category'], showCustomCols: true });
    }
    if (window.innerWidth <= 1270) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['teacherName', 'category', 'status'] , showCustomCols: true });
    }
    if (window.innerWidth <= 1045) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['teacherName', 'category', 'status', 'isRegistered'], showCustomCols: true });
    }
    if (window.innerWidth <= 900) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['teacherName', 'category', 'status', 'isRegistered', 'numBookings'], showCustomCols: true });
    }
    if (window.innerWidth <= 770) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['teacherName', 'category', 'status', 'isRegistered', 'numBookings', 'endDate'], showCustomCols: true });
    }
    if (window.innerWidth <= 600) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['teacherName', 'category', 'status', 'isRegistered', 'numBookings', 'endDate', 'language'], showCustomCols: true });
    }
    if (window.innerWidth <= 478) {
        dispatch({ type: 'HIDDEN_COLUMNS_AND_CUSTOM_COLS', hiddenColumns: ['teacherName', 'category', 'status', 'isRegistered', 'numBookings', 'endDate', 'language', 'startDate'], showCustomCols: true });
    }
}